// extracted by mini-css-extract-plugin
var _1 = "VerificationEntry-module__animatedBackground--k7_9h";
var _2 = "VerificationEntry-module__container--OJPOw";
var _3 = "VerificationEntry-module__dateRange--Ge6QK";
var _4 = "VerificationEntry-module__verifier--WpC2O";
var _5 = "VerificationEntry-module__verifierName--I20f7";
export { _1 as "animatedBackground", _2 as "container", _3 as "dateRange", _4 as "verifier", _5 as "verifierName" }
